module.exports = __webpack_public_path__ + "static/luminous_4-626251b54ed0cea13e11ee33975891f2.jpg";